import BottomDecoration from "@/assets/img/compatibility/bottom-decoration.png"

/**
 * Optional ambient decoration at the bottom of a quiz step (Figma "Bottom
 * decoration") — a soft magenta glow with sparkles, pre-rendered with its top
 * fade on transparency, so it just overlays the dark base. Enable per step via
 * `bottomDecoration: true`.
 */
export function QuizBottomDecoration() {
  return (
    <img
      src={BottomDecoration}
      alt=""
      className="pointer-events-none absolute inset-x-0 bottom-0 z-0 w-full"
    />
  )
}
